module.exports = "<app-engine-report\n[isHoursReadGreaterThan10000] = \"isHoursReadGreaterThan10000\"\n></app-engine-report>\n"